import React from 'react'
import {Modal} from 'common/styleguide/Modal'
import {Overlay} from 'common/styleguide/Overlay'

export const ModalOverlay = ({maxWidth, maxHeight, shouldCloseOnOverlayClick, onRequestClose, ...props}) => (
  <Overlay
    maxWidth={maxWidth}
    maxHeight={maxHeight}
    shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    onRequestClose={onRequestClose}>
    <Modal {...props} onRequestClose={onRequestClose} />
  </Overlay>
)
